import React from "react";
interface props {
  className?: string;
  fill?: string;
  pathFill?: string;
}

function MailIcon({ className, fill, pathFill }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      className={className}
      fill="none"
      viewBox="0 0 42 42"
    >
      <rect width="42" height="42" fill={fill || "#FEECE6"} rx="21"></rect>
      <path
        fill={pathFill || "#FF752C"}
        fillRule="evenodd"
        d="M14.2 14.2l7.56 5.67a.4.4 0 00.48 0l7.56-5.67H14.2zm16.6.75l-7.84 5.88a1.6 1.6 0 01-1.92 0l-7.84-5.88V27.8h17.6V14.95zM13 13h18a1 1 0 011 1v14a1 1 0 01-1 1H13a1 1 0 01-1-1V14a1 1 0 011-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default MailIcon;
